import { ReactNode } from 'react'

import { TileBody } from './styles'

interface IBodyProps {
  children: ReactNode
}

export function Body({ children }: IBodyProps) {
  return <TileBody>{children}</TileBody>
}
